import Star from 'components/icons/Star';
import useAnalyticsCallback from 'hooks/useAnalyticsCallback';

const StarRating = ({
  onChange = () => {},
  rating = null,
  disabled,
  uniqueId,
  customOutlineColor,
  starClassNames = '',
  starSvgClassName = '',
  ratingSubmittedEvent,
  mealTitle,
}) => {
  const isHighlighted = num => {
    return rating && num <= rating;
  };

  const onRatingChange = useAnalyticsCallback(
    num => onChange(num),
    ({ logEvent, callbackArgs }) => {
      const [num] = callbackArgs;

      if (ratingSubmittedEvent) {
        logEvent(ratingSubmittedEvent, {
          mealTitle,
          rating: num,
        });
      }
    }
  );

  return (
    <div className="input--rating whitespace-nowrap">
      {[5, 4, 3, 2, 1].map(num => {
        const id = `star_${uniqueId}_${num}`;
        const buttonDisabled = disabled;

        return (
          <label
            key={num}
            className={`${starClassNames} input--rating__option ${num}${isHighlighted(num) ? ' is--highlighted' : ''}`}
            htmlFor={id}
          >
            <button
              disabled={buttonDisabled}
              id={id}
              data-testid={id}
              onClick={() => onRatingChange(num)}
              type="button"
              className={buttonDisabled ? 'cursor-default' : ''}
            >
              <span className="sr">{`Rate meal ${num} star${num === 1 ? '' : 's'}`}</span>
              <Star
                className={starSvgClassName}
                fill={'star-with-stroke__fill text-white-100'}
                outline={
                  rating
                    ? 'star-with-stroke__stroke'
                    : customOutlineColor || 'star-with-stroke__stroke'
                }
              />
            </button>
          </label>
        );
      })}
    </div>
  );
};

StarRating.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  rating: PropTypes.oneOfType([PropTypes.number, AirbnbPropTypes.explicitNull()]),
  uniqueId: PropTypes.string.isRequired,
  customOutlineColor: PropTypes.string,
  starClassNames: PropTypes.string,
  starSvgClassName: PropTypes.string,
  ratingSubmittedEvent: PropTypes.string,
  mealTitle: PropTypes.string,
};

export default StarRating;
